import React from "react";
import ReactPlayer from "react-player";
import "./style.css";

const Video = ({
  url,
  controls = true,
  playing = true,
  loop = true,
  muted = true,
  forceHLS = false,
  onProgress,
  onBufferEnd,
  onBuffer,
  onError,
}) => {
  console.log(forceHLS);

  if (forceHLS) {
    return (
      <ReactPlayer
        className="react-player  shipinjuzhong"
        url={url}
        playing
        loop
        muted
        controls
        width="100%"
        height="100%"
        onProgress={(e) => {
          onProgress?.(e);
          // console.log(e);
        }}
        onBuffer={(e) => {
          onBuffer?.(e);
          // console.log(e);
        }}
        onBufferEnd={(e) => {
          onBufferEnd?.(e);
          // console.log(e);
        }}
        onError={(e) => {
          onError?.(e);
          // console.log(e);
        }}
        config={{
          file: {
            forceHLS: true,
          },
        }}
      />
    );
  }

  return (
    <ReactPlayer
      className="react-player  shipinjuzhong"
      url={url}
      playing
      loop
      muted
      controls
    />
  );
};

export default Video;
